export function createStateRepository(config) {
    const { repository, client: api } = config;
    const PREFIX = ['conversations', 'state'];
    // Helper function to generate consistent query keys
    const getQueryKey = (context) => [
        ...PREFIX,
        context.principal?.id,
    ];
    return {
        useCreate(context) {
            const mutation = repository.useMutation(context, {
                async mutationFn(props) {
                    const response = await api.stateCreate({
                        stateCreateRequest: props,
                    });
                    return response.data;
                },
            });
            return mutation;
        },
    };
}
//# sourceMappingURL=assistantStateRepository.js.map